import $_request from '../../utils/request';
var state = {
    pushData: null,
    pushReport: null,
    timesData: null,
    preCalculate: {},
    vehicleCount: {
        inventoryCount: 0,
        signedCount: 0,
    },
    qrStatus: null,
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_PUSHDATA: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $_request({
            url: '/proxy/violation/push/get',
            method: 'post',
        }).then(function (res) {
            if (res.errorCode === 0) {
                commit('update', {
                    pushData: res.data,
                });
            }
        });
    },
    GET_REPORT: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $_request({
            url: '/proxy/violation/push/report',
            method: 'post',
        }).then(function (res) {
            if (res.errorCode === 0) {
                commit('update', {
                    pushReport: res.data || null,
                });
            }
        });
    },
    GET_COSTCOUNT: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $_request({
            url: '/proxy/violation/analyze/times',
            method: 'post',
        }).then(function (res) {
            if (res.errorCode === 0) {
                commit('update', {
                    timesData: res.data,
                });
            }
        });
    },
    GET_PRECALCULATE: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        if (params === void 0) { params = { data: {}, loadingControl: 'auto', loading: null }; }
        var data = params.data, loadingControl = params.loadingControl, loading = params.loading;
        $_request({
            url: '/proxy/violation/preCalculate',
            method: 'post',
            data: data,
            loadingControl: loadingControl,
        }).then(function (res) {
            if (res.errorCode === 0) {
                commit('update', {
                    preCalculate: res.data,
                });
                return;
            }
            loading && loading.close();
        });
    },
    GET_VEHICLE_COUNT: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $_request({
            url: '/proxy/api/vehicle/count',
            method: 'post',
        }).then(function (res) {
            if (res.errorCode === 0) {
                commit('update', {
                    vehicleCount: res.data,
                });
            }
        });
    },
    GET_QR_STATUS: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        if (params === void 0) { params = { purchaseCode: '', callback: function (res) { } }; }
        commit('update', {
            qrStatus: null,
        });
        var purchaseCode = params.purchaseCode, callback = params.callback;
        var checkStatus = function () {
            $_request({
                url: '/proxy/violation/purchase/status',
                method: 'post',
                loadingControl: 'hand',
                data: { purchaseCode: purchaseCode },
            }).then(function (res) {
                if (!res)
                    return;
                callback(res);
            });
        };
        checkStatus();
    },
    PURCHASE_TIME: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        if (params === void 0) { params = { data: {}, loadingControl: 'auto', loading: null, callback: function (res) { } }; }
        var data = params.data, loadingControl = params.loadingControl, callback = params.callback;
        $_request({
            url: '/proxy/violation/purchase/do',
            method: 'post',
            data: data,
            loadingControl: loadingControl,
        }).then(function (res) {
            if (!res)
                return;
            callback && callback(res);
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
